import type { CloudAPI } from '@yandex-360/telemost-sdk/cloud-api';

import { ArtifactRecipient } from '../features/fetching/types';

export const convertRecipient = ({
    display_name,
    email,
    role,
}: CloudAPI.ConferenceArtifacts.Recipient): ArtifactRecipient => ({
    displayName: display_name,
    email: email || null,
    role,
});
